// 32ecc37db61fa70464333dd9db4b756d8a985b28|className=CountryApi|type=angular|apiName=entity|apiEnumKey=Entity|operationHash=e5dadf3d99162d53c659aeba55b588d67d90e766|kind=api-js

import * as i0 from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Api } from '@myre/common-conf';
import {
  DynamicEnvService,
  AngularSdk,
} from '@myre/ui-domain-http';
import { parseOkResponseFromJSON } from '../../../parsers/OkResponse';

import { parseCountryFromJSON } from '../../../parsers/Country';

export class CountryApi extends AngularSdk {
  constructor(
    dynamicEnvService,
    httpClient,
  ) {
    super(dynamicEnvService, httpClient);
  }

  /**
   * @tags CountryApi
   * @name CountryApiGetCountries
   * @summary Get all countries
   * @request GET:/countries
   */
  getCountries(
    requestOptions = {},
  ) {
    return this._request(
      {
        path: `/countries`,
        method: 'GET',
        api: Api.Entity,
      },
      {
        ...requestOptions,
        parser: data => parseOkResponseFromJSON(data, {
    contentParser: parseCountryFromJSON,
    isContentArray: true,
  }),
      },
    );
  }

  static ɵfac = function CountryApi_Factory(t) { return new (t || CountryApi)(i0.inject(DynamicEnvService), i0.inject(HttpClient)); };
  static ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({ token: CountryApi, factory: CountryApi.ɵfac, providedIn: 'root' });
}
